import { NavLink } from 'react-router-dom';
import { Typography } from 'omakase';

interface Props {
  navItems: NavItem[];
}

interface NavItem {
  text: React.ReactNode;
  id: string | number;
  to: string;
}

const ProfileListSideNav: React.FunctionComponent<Props> = ({ children, navItems }) => {
  return (
    <div className="ReservationsPage">
      <div className="ReservationsPage-activeListPickerSection">
        {navItems.map((navItem) => (
          <NavLink
            key={navItem.id}
            to={navItem.to}
            className="ReservationsPage-listPickerItem"
            activeClassName="is-selected"
          >
            <Typography variant="body02Strong" className="ReservationsPage-listPickerItemText">
              {navItem.text}
            </Typography>
          </NavLink>
        ))}
      </div>
      <div className="ReservationsPage-reservationsSection">{children}</div>
    </div>
  );
};

export default ProfileListSideNav;
